import { ReportWorkbookCellStyle, ReportWorkbookPreviewSheet } from '../models/report-app.model';
import { WorksheetCellMeta, WorksheetSaveSheet } from '../../worksheet-app/models/worksheet-app.model';

/**
 * The preview's compact sheets → the Workbooks Import shape: each row's style numbers become one cell entry per styled
 * cell, row by row and column by column — the order the server's mapper writes them in. Each hyperlink becomes its
 * cell's {@code link} (a linked cell without a style gets an entry of its own).
 */
export function expandWorkbookPreviewSheets(sheets: ReadonlyArray<ReportWorkbookPreviewSheet>): ReadonlyArray<WorksheetSaveSheet> {
	return sheets.map((sheet: ReportWorkbookPreviewSheet): WorksheetSaveSheet => {
		const styles: ReadonlyArray<ReportWorkbookCellStyle> = sheet.tableStructure.fscCellStyles;
		const links: Map<string, string> = new Map<string, string>(
			(sheet.tableStructure.fscCellLinks ?? []).map(([row, col, url]: readonly [number, number, string]): [string, string] => [`${row}:${col}`, url])
		);
		const cells: WorksheetCellMeta[] = [];
		for (const line of sheet.tableStructure.fscCellStyleRows) {
			const rowIndex: number = line[0];
			for (let col: number = 1; col < line.length; col++) {
				const style: ReportWorkbookCellStyle | undefined = line[col] > 0 ? styles[line[col] - 1] : undefined;
				if (style) {
					const key: string = `${rowIndex}:${col - 1}`;
					const link: string | undefined = links.get(key);
					links.delete(key);
					cells.push(link ? { rowIndex, colIndex: col - 1, ...style, link } : { rowIndex, colIndex: col - 1, ...style });
				}
			}
		}
		links.forEach((link: string, key: string): void => {
			const [rowIndex, colIndex]: number[] = key.split(':').map(Number);
			cells.push({ rowIndex, colIndex, link });
		});
		return {
			name: sheet.name,
			tableData: sheet.tableData,
			tableStructure: { initSettings: sheet.tableStructure.initSettings, fscCellSettings: cells },
		};
	});
}
